import { Dot } from '@givebutter/primitives/dot';
import { transformQuickBooksTransactionStatusToReadable } from 'components/filter/filters-next/readable';
import * as Tooltip from 'components/tooltip';
import { useCurrentTransactionOrById } from 'customHooks/useCurrentTransactionOrById';
import { twMerge } from 'tailwind-merge';

const TransactionQuickBooksStatusBadge = () => {
    const { data: transaction } = useCurrentTransactionOrById();
    const status = transaction.integrations?.quickbooks.mapping?.status;

    return (
        <Tooltip.Root>
            <Tooltip.Trigger disabled={!status} asChild>
                <div className="relative">
                    <img
                        alt="QuickBooks"
                        className="max-h-6"
                        src={`/images/logos/quickbooks_logo.svg`}
                    />
                    <QuickBooksStatusIndicator />
                </div>
            </Tooltip.Trigger>
            <Tooltip.Portal>
                <Tooltip.Content inverse>
                    <Tooltip.Arrow inverse />
                    {status && (
                        <p>QuickBooks: {transformQuickBooksTransactionStatusToReadable(status)}</p>
                    )}
                </Tooltip.Content>
            </Tooltip.Portal>
        </Tooltip.Root>
    );
};

const QuickBooksStatusIndicator = () => {
    const { data: transaction } = useCurrentTransactionOrById();

    if (!transaction.integrations?.quickbooks.mapping?.status) {
        return null;
    }

    const bgClass = {
        synced: 'bg-success-500',
        do_not_sync: 'bg-gray-600',
        ready_to_sync: 'bg-blue-500',
        issues: 'bg-warning-700',
        before_historical_date: 'bg-gray-500',
        syncing: 'bg-blue-500',
    }[transaction.integrations.quickbooks.mapping.status];

    return (
        <Dot
            className={twMerge('absolute -bottom-1 -right-1 size-3 border-2 border-white', bgClass)}
        />
    );
};

export { TransactionQuickBooksStatusBadge };
